import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { useLocation } from 'react-router-dom';
import CheckoutForm from "./organisms/CheckoutForm";

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_test_51PVz5RRs4FkNLzthMMBdpqqUwNIVY6LoulizsrwyLGJ5EofhVLL9IXyboOdJiGiqbqr3lP7zJVyaj8SyR1Ll0XDi00cae1qXFX');

const CheckoutPage = () => {
  const location = useLocation();
  const { product } = location.state || {};
  const [clientSecret, setClientSecret] = useState('');
  const [error, setError] = useState(null);

  // Fetch the clientSecret from the backend on mount
  useEffect(() => {
    if (product) {
      console.log("Product info received:", product);

      fetch('https://createpaymentintent-kjhk3pjbfq-uc.a.run.app', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: product.price, // Pass the price from PaymentPage
          product_id: product.product_id, // Pass the product ID
          description: product.name, // Pass the product name
          connected_account_id: product.account, // Pass the connected account ID
        }),
      })
        .then((res) => {
          console.log("Fetch response status:", res.status);
          console.log("Fetch response OK:", res.ok);

          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }

          return res.json();  // Ensure proper parsing of JSON response
        })
        .then((data) => {
          console.log('Response JSON data:', data); // Log the entire response JSON

          if (data && data.client_secret) {
            console.log('clientSecret:', data.client_secret);  // Access the correct field
            setClientSecret(data.client_secret); // Correctly store the client_secret in state
          } else {
            console.error('No client_secret received from backend:', data);
          }
        })
        .catch((error) => {
          console.error('Error fetching client_secret:', error); // Log any errors
          setError('Failed to load payment form. Please try again later.');
        });
    } else {
      console.error('No product data provided.');
    }
  }, [product]);

  // Stripe Elements options
  const options = { clientSecret };

  if (!product) {
    return <div>No product information provided</div>;
  }

  return (
    <div>
      <h2>Complete Payment</h2>
      <p>Connected Account ID: {product.account}</p>
      <p>Product: {product.name}</p>
      <p>Price: ${product.price}</p>

      {error && <p>{error}</p>}

      {/* Only show the form if the clientSecret is available */}
      {clientSecret && product && (
        <Elements stripe={stripePromise} options={options}>
          <CheckoutForm clientSecret={clientSecret} product={product} />
        </Elements>
      )}

      {!clientSecret && !error && <p>Loading payment form ...</p>} {/* Show a loading message */}
    </div>
  );
};

export default CheckoutPage;
